import React, { useEffect, useState } from 'react';
import { Container, Col } from 'react-bootstrap';
import { AiOutlineUser } from 'react-icons/ai';
import { Auth } from '../Auth';
import PageHeader from 'Utils/PageHeader';
import UserPanel from './UserPanel';

const User = (props) => {
  const [user, setUser] = useState({});
  
  useEffect(() => {
    const fetchUser = async() => {
      let response = await Auth.getUser();
      // console.log('USER', response)
      setUser(response);
    }
    fetchUser();
  }, []);

  return (
    <Col className='p-0'>
      <Container fluid>
        <Container>
          <PageHeader
            header='My Profile'
            icon={AiOutlineUser}
            tooltip='Your account data.'
          />
          <div className='user-panel-container'>
            <UserPanel user={user} licenseData={props.licenseData} version={props.config?.VERSION} />
          </div>
        </Container>
      </Container>
    </Col>
  );
}

export default User;